import { Language } from '../../models/language.model';

/**
 * This state should store all UI variables, which are not related directly to the user (like language, which can be changed also when user is not logged in).
 */
export interface UIState {
  languageList: Language[];
  error: any;
}

export const initialState: UIState = {
  languageList: [],
  error: null
};
